<ng-template #loading>
    <syn-page-loader [loading]="true"></syn-page-loader>
</ng-template>

<form *ngIf="formValues | async; else loading" [formGroup]="slaForm">
    <div fxLayout="row" fxLayoutGap="45px">
        <section class="period-section">
            <h1>Période Heures Ouvrées contractuelle</h1>
            <p class="subtitle">Période pendant laquelle la création d'un ticket sera considérée comme étant en heures
                ouvrées</p>

            <div>
                <syn-picker formControlName="periodReplyTime" [contentLoader]="periodReplyPickerContentLoader"
                    placeholder="Période Heures Ouvrées contractuelle" [content]="periodReplyPicker$"
                    [itemTemplate]="periodItemTemplate" [strictSearch]="false" subscriptSizing="dynamic"
                    required></syn-picker>
                @if (periodReplyTime) {
                <syn-project-wizard-sla-period [period]="periodReplyTime" />
                }
            </div>
        </section>

        <section class="period-section">
            <h1>Urgence et période de traitement</h1>
            <p class="subtitle">Urgence(s) et période(s) de traitement des incidents. L'urgence intervient notamment
                dans le calcul de la priorité d'un incident</p>

                <div fxLayout="row" fxLayoutGap="8px" fxLayoutAlign="start center">
                    <mat-slide-toggle color="primary" formControlName="multiSla">
                        Mode multi-SLA
                    </mat-slide-toggle>
                    <a class="small-icon-button"
                        mat-icon-button
                        matTooltip="Consulter la documentation"
                        href="https://claranet-fr.atlassian.net/wiki/x/T4Awh"
                        target="_blank"
                        rel="noopener noreferrer"
                        aria-label="Plus d'informations">
                            <mat-icon svgIcon="information-outline"></mat-icon>
                    </a>
                </div>

            <p class="subtitle mb toggle-details">Permet de disposer de deux niveaux d'urgence et deux périodes de
                traitement (heures ouvrées et 24/7) au sein d'un même projet</p>

            @if (isMultiSla) {
            <div class="mb">
                <syn-picker formControlName="periodResponseTime" placeholder="Période Heures Ouvrées"
                    [contentLoader]="periodResponsePickerContentLoader" [content]="periodResponsePicker$"
                    [itemTemplate]="periodItemTemplate" [strictSearch]="false" subscriptSizing="dynamic" required
                    fxFlexFill></syn-picker>
                <syn-project-wizard-sla-period *ngIf="periodResponseTime"
                    [period]="periodResponseTime"></syn-project-wizard-sla-period>
            </div>

            @if (periodResponseTime) {
            <p>Liste des SLAs pouvant être configurés sur les <b>inventaires</b> (si non configuré, c'est le SLA par
                défaut qui sera appliqué)</p>
            <syn-project-wizard-sla-service-levels formControlName="defaultServiceLevel" [periods]="periods"
                [serviceLevels]="slaForm.controls['serviceLevels'].value" />
            }
            } @else {
            <div class="mb">
                <mat-form-field class="syn--full-width" appearance="outline">
                    <mat-label>Urgence</mat-label>
                    <mat-select placeholder="Urgence" formControlName="urgency" class="syn--full-width">
                        <mat-option *ngFor="let urgency of allowedUrgency" [value]="urgency.value">
                            {{ urgency.translate }}
                        </mat-option>
                    </mat-select>
                </mat-form-field>

                <div>
                    <syn-picker formControlName="periodResponseTime" placeholder="Période de traitement"
                        [contentLoader]="periodResponsePickerContentLoader" [content]="periodResponsePicker$"
                        [itemTemplate]="periodItemTemplate" [strictSearch]="false" subscriptSizing="dynamic" required
                        fxFlexFill></syn-picker>
                    <syn-project-wizard-sla-period *ngIf="periodResponseTime"
                        [period]="periodResponseTime"></syn-project-wizard-sla-period>
                </div>
            </div>
            }
        </section>
    </div>

    <section>
        <div fxLayout="row" fxLayoutAlign="space-between center">
            <div>
                <h1>GTI / GTR</h1>
                <p class="subtitle">Temps de prise en compte (GTI), et temps de résolution (GTR) des tickets</p>
            </div>
            <button (click)="openLoadTemplateDialog()" mat-stroked-button type="button" color="primary">
                <mat-icon svgIcon="download-outline"></mat-icon>
                Charger un modèle
            </button>
        </div>

        <div class="list-gti-gtr mb">
            <syn-project-wizard-sla-gti-gtr-edit *ngFor="let sla of getSlaFormControls()" class="gti-gtr"
                [formGroup]="sla" />
        </div>
    </section>
</form>

<ng-template #periodItemTemplate let-name="content.name" let-id="content.id">
    <div fxLayout="row" fxLayoutAlign="space-between center" [matTooltip]="id">
        <span class="template_header">{{ name }}</span>
    </div>
</ng-template>